import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import {
  modalHeightVariants,
  modalVariants,
} from "../../animation/RoutesAnimations";
import { popupClickOutside } from "../../utils/clickOutside";

interface Props {
  isOpen: boolean;
  children: React.ReactNode;
  onClose: () => void;
  position?: string;
  noneSpace?: boolean;
}

export default function Popup(props: Props) {
  const ref = useRef<any>(null);
  const { children, isOpen, onClose, position = "left-0 top-16" } = props;
  const stopPropagation = (e: any) => {
    e.stopPropagation();
  };
  useEffect(() => {
    popupClickOutside(ref, onClose);
  }, []);
  return (
    <>
      {isOpen && (
        <motion.div
          ref={ref}
          layout
          variants={{
            initial: {
              height: 0,
              opacity: 0,
            },
            final: {
              height: "auto",
              opacity: 1,
              transition: {
                duration: 0.2,
                delay: 0.2,
              },
            },
          }}
          initial="initial"
          animate="final"
          whileInView={{
            //@ts-ignore
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px",
          }}
          className={`absolute overflow-hidden bg-white rounded-lg ${position} z-[5000]`}
        >
          <motion.div
            layout={"position"}
            initial="initial"
            animate="final"
            className="relative shadow-modal"
            style={{
              //@ts-ignore
              boxShadow:
                "box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
            }}
            onClick={stopPropagation}
          >
            <div
              className={`bg-white rounded-lg relative ${
                props.noneSpace ? "" : "p-4"
              } shadow-modal`}
            >
              {children}
            </div>
          </motion.div>
        </motion.div>
      )}
    </>
  );
}
